<template>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:3}">
      <a-tabs v-model:activeKey="activeKey" default-active-key="1">
        <a-tab-pane key="1" tab="基础信息">
          <a-form-item label="模板名称" name='name' >
            <a-input v-model:value="form.name" style="width:200px" :width="200"></a-input>
          </a-form-item>
          <a-form-item label="备注" name='remarks' :wrapper-col="{span:7}">
            <a-textarea v-model:value="form.remarks" showCount :maxlength="50"></a-textarea>
          </a-form-item>
          <a-form-item label="获取用户地理位置" name='is_address' :wrapper-col="{span:15}" v-if="$route.query.type!=5&&$route.query.type!=6">
            <customizeSwitch v-model:value="form.is_address" :value="form.is_address" />
            <div v-if="form.is_address" class="s_bf7 p-10">
              <a-form-item label="强制获取地理位置" required :label-col="{span:4}" help="（选择是，则用户扫码时必须先同意获取地理位置，才能参与领奖。该设置会影响消费者领奖体验，请谨慎开启！）">
                <a-radio-group name="is_force_address" v-model:value="form.is_force_address">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>   
          </a-form-item>
          <a-form-item label="自动打标签" name='is_tag' :wrapper-col="{span:20}">
            <customizeSwitch v-model:value="form.is_tag" :value="form.is_tag" />
            <a-card v-if="form.is_tag">
              <div class="m-b-10 ">
                <a-button type="primary" @click="tagsVisible=true">新增标签</a-button>
              </div>
              <a-table :pagination='false' bordered rowKey='member_id' :columns='columns' :data-source='form.tags'>
                <template v-slot:condition="{ record }">
                  <p v-if="record.tag_type==1">活动期间内,不限来源,达{{record.award_count}}次</p>
                  <p v-else>活动期间内,扫码地区为{{record.province}}{{record.city}}{{record.district}}</p>
                </template>
                <template v-slot:tags="{ record }">
                  <a-tag color="blue" v-for="v in record.tag_names" :key="v">{{v}}</a-tag>
                </template>
                <template v-slot:action="{ record,index }">
                  <a href="javascript:;" @click="edit(record)" class="m-r-10">编辑</a>
                  <a href="javascript:;" @click="del(record,index)">删除</a>
                </template>
              </a-table>
            </a-card>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane key="3" tab="广告页" forceRender v-if='$route.query.type == 3'>
          <advert :ad_data="ad_data" ref="adComponent"></advert>
        </a-tab-pane>
        <a-tab-pane key="2" tab="页面装修" forceRender>
          <component v-if='$route.query.type&&template_data' :is="switchTemplateType($route.query.type)" :template_data="template_data" ref="templateComponent" :antis_fake_tem_data="form.antis_fake_tem_data" v-on:upadteAntisdata="upadteAntisdata"></component>
        </a-tab-pane>
      </a-tabs>
      <div class="btns">
        <a-button type="primary" @click="submit" class='m-l-30 m-t-10 m-r-10'>
          保存
        </a-button>
      </div>
    </a-form>
  </a-card>
  <a-modal  :keyboard="false" v-model:visible="tagsVisible" title="奖品发放策略" centered style="width:700px;" :footer='null' :width='700' destroyOnClose>
    <tags ref="tagsComponents" v-on:cancel="tagsVisible=false" v-on:confirm="confirmTags" />
  </a-modal>
</template>
<script>
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import tags from "./components/tags";
import config from "@/config";
import normal from "./diyComponents/normal/index";
import traceability from "./diyComponents/traceability/index";
import guideTemplate from "./diyComponents/guideTemplate/index";
import turnTable from "./diyComponents/turnTable/index";
import userTemplate from "./diyComponents/userTemplate/index";
import store from "./diyComponents/store/index";
import modules from "./diyComponents/normal/module.js"; //基础组件数据
import advert from "./diyComponents/advert/index"; //广告页
import * as Icon from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import {
  setTemplates,
  detailTemplates,
  updateTemplates,
  deleteTags,
  updateTags,
  createTags,
} from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
const allComponents = require.context('./diyComponents/customerTemplate', true,/index$/)
let res_components = {}
allComponents.keys().forEach(fileName => {
  let comp = allComponents(fileName)
  res_components[fileName.replace(/^\.\/(.*)\.\w+$/, '$1').split('/')[1]] = comp.default
})
const rules = {
  name: [{ required: true, message: "请输入模板名称" }],
};
const def = {
  name: "",
  remarks: "",
  type: "",
  template_thumb: "",
  template_content: {},
  tags: [],
  is_address: 0,
  is_force_address: 1,
  is_tag: 0,
  id: "",
};
const columns = [
  {
    title: "条件",
    dataIndex: "condition",
    key: "condition",
    slots: { customRender: "condition" },
  },
  {
    title: "标签",
    dataIndex: "tags",
    key: "tags",
    slots: { customRender: "tags" },
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: { ...Icon, tags, normal, store, traceability,turnTable,userTemplate,...res_components,guideTemplate,advert },
  setup() {
    const switchTemplateType = (type) => {
      var typeText = "";
      switch (type) {
        case "1":
          // 普通H5模板
          typeText = "normal";
          break;
        case "2":
          // 云店模板
          typeText = "store";
          break;
        case "3":
          // 溯源模板
          if($route.query.mark){
             // 定制模板
             typeText = $route.query.mark;
          }else{
             typeText = "traceability";  
          }
          console.log(typeText)

          break;
        case "4":
          // 大转盘模板
          typeText = "turnTable";
          break;
        case "5":
          // 领取会员卡模板
          typeText = "userTemplate";
        break;
        case "6":
          // 导购模板
          typeText = "guideTemplate";
        break;
               default :
          // 定制模板
           typeText = type;
        break;
      }
      return typeText;
    };

    const activeKey = ref("1");
    const oss = config.oss[process.env.VUE_APP_type];
    const form = ref(def);
    const ruleForm = ref();
    const ad_data = ref({});
    // 新增标签
    const tagsVisible = ref(false);
    // 新增或编辑确认
    const confirmTags = async (e) => {
      if ($route.query.id&&$route.query.is_default != 1) {
        if (e.id) {
          let result = await updateTags({
            template_id: $route.query.id,
            ...e,
            template_tag_id:e.id
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
             var index=0;
           form.value.tags.forEach((v,key)=>{
              if(v.id==e.id){
                index=key
              }
            })
            form.value.tags[index]=e
            // form.value.tags.push({
            //   ...e,
            //   id: result.data.id,
            // });
          }
        } else {
          let result = await createTags({
            template_id: $route.query.id,
            ...e,
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            form.value.tags.push({
              ...e,
              id: result.data.id,
            });
          }
        }
      } else {
        form.value.tags.push(e);
      }
      tagsVisible.value = false;
    };
    // 编辑
    const tagsComponents = ref();
    const edit = (data) => {
      tagsVisible.value = true;
      setTimeout(() => {
        tagsComponents.value.detail(data);
      }, 100);
    };
    const $Modal = inject("$Modal");
    const del = async (data, index) => {
      if (data.id) {
        $Modal.confirm({
          centered: true,
          content: `您确定要将该标签删除后无法还原`,
          onOk: async () => {
            let res = await deleteTags({
              template_id: $route.query.id,
              template_tag_id: data.id,
            }).then((res) => res.data);
            if (iscode(res)) {
              $Modal.destroyAll();
              form.value.tags.splice(index, 1);
            }
          },
        });
      } else {
        form.value.tags.splice(index, 1);
      }
    };
    const templateComponent = ref();
    const $router = inject("$router");
    const $route = inject("$route");
    const template_data = ref(false);
    const submit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          let result = {};
          // 获取截图信息
          const hide = message.loading('生成缩略图中...', 0);
          var thumb=await templateComponent.value.getThumb().then(res=>res).catch(error=>error) 
          console.log(thumb,'------1')
           setTimeout(hide);
          if ($route.query.is_default == 1) {
            result = await setTemplates({
              ...form.value,
              template_thumb: thumb,
              template_content: templateComponent.value.submit(),
              mark:$route.query.mark
            })
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await updateTemplates($route.query.id, {
              ...form.value,
              template_thumb: thumb,
              template_content: templateComponent.value.submit(),
              mark:$route.query.mark,
            })
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            $router.go(-1);
          }
        })
        .catch((error) => {
          console.log(error);
          message.error("请完善资料");
        });
    };
    onMounted(async () => {
     // 模板声明 type 1 普通扫码模板 2 云店模板 3 溯源模板 4.大转盘（普通） 5.会员卡（普通） 6.导购模板  mark  标记客户定制
      form.value.type = $route.query.type;
      if ($route.query.id) {
        let result = await detailTemplates($route.query.id)
          .then((res) => res.data)
          .catch((error) => error);
        form.value.id = $route.query.id;
        if (iscode(result)) {
          form.value = result.data;
          template_data.value = result.data.template_content;
          ad_data.value = result.data.advertising_page_content;
        }
      }
    });
    // 更新关联模板数据
    const upadteAntisdata=(data)=>{
      // var targert=template_data.value.tracePage.items[data.moduleIndex].data[data.index]
      // 获取需要跟新的模块的原始值 与 数据对比 替换还是更新
      if(data.origin&&form.value.antis_fake_tem_data&&form.value.antis_fake_tem_data.length){
        var flag=-1
          form.value.antis_fake_tem_data.forEach((v,k)=>{
              if(v.antis_fake_tem_id==data.origin){
                flag=k
              }
          })
          if(flag!=-1){
            form.value.antis_fake_tem_data[flag]={
                antis_fake_tem_id:data.antis_fake_tem_data.id,
              antis_fake_tem_title:data.antis_fake_tem_data.name
            }
          }
      }else{
        form.value.antis_fake_tem_data.push({
          antis_fake_tem_id:data.antis_fake_tem_data.id,
          antis_fake_tem_title:data.antis_fake_tem_data.name
        })
      }
    }
    return {
      oss,
      modules,
      form,
      ruleForm,
      columns,
      tagsVisible,
      confirmTags,
      del,
      edit,
      tagsComponents,
      templateComponent,
      submit,
      rules,
      template_data,
      activeKey,
      switchTemplateType,
      upadteAntisdata,
      ad_data
    };
  },
};
</script>
<style lang="less" scoped>
.btns {
  position: fixed;
  bottom: 0;
  text-align: center;
  z-index: 100;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 10px;
  width: 100%;
  box-shadow: -1px 2px 20px 0 rgba(0, 0, 0, 0.3);
}
</style>
